import * as React from 'react'

import { useLocation } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import URI from '../../../misc/classes/URI'
import { ISponsorshipsResponse } from '../../../models/Sponsorship'
import routes from '../../../router/routes'
import { useCurrentBreadcrumb } from '../../../state/breadcrumbs/hooks/useCurrentBreadrumb'
import { locale } from '../../../state/locale/atoms/locale'
import { translate } from '../../../state/locale/selectors/translate'
import PageWrapper from '../../_layout/PageWrapper'
import Breadcrumbs from '../../reusable/Breadcrumbs'
import { Loading } from '../../reusable/Loading'
import { Sponsorship } from '../../templates/Sponsorship'

const SponsorshipPage = () => {
  const i18n = useRecoilValue(translate).sponsorship
  const breadcrumbs = [
    {
      link: routes.sponsorship,
      title: i18n.breadcrumb,
    },
  ]
  const { pathname } = useLocation()
  const slug = pathname.split('/', 3)[2]
  const lang = useRecoilValue(locale)
  const { data, isValidating } = useSWR<ISponsorshipsResponse>(URI.getSponsorshipUri(slug, lang))
  useCurrentBreadcrumb(data?.data[0]?.title || '')

  return (
    <>
      <PageWrapper>
        <Breadcrumbs base={breadcrumbs} />
        {isValidating && <Loading />}
        {!!data?.data[0] && <Sponsorship data={data.data[0]} />}
      </PageWrapper>
    </>
  )
}

export default SponsorshipPage
